(function () {
  Flint.file("views/pages/tsaPage.js", function (require) {
    Flint.staticStyles("TsaPage", {
      "$tsa": "#_flintapp tsa.TsaPage, #_flintapp .TsaPage.tsa, #_flintapp .ViewTsaPage.tsa, #_flintapp .TsaPage > .tsa",
      "$topSection": "#_flintapp topSection.TsaPage, #_flintapp .TsaPage.topSection, #_flintapp .ViewTsaPage.topSection, #_flintapp .TsaPage > .topSection",
      "$tsaBookLink": "#_flintapp tsaBookLink.TsaPage, #_flintapp .TsaPage.tsaBookLink, #_flintapp .ViewTsaPage.tsaBookLink, #_flintapp .TsaPage > .tsaBookLink",
      "$tsaBookImg": "#_flintapp tsaBookImg.TsaPage, #_flintapp .TsaPage.tsaBookImg, #_flintapp .ViewTsaPage.tsaBookImg, #_flintapp .TsaPage > .tsaBookImg",
      "$mainPitch": "#_flintapp mainPitch.TsaPage, #_flintapp .TsaPage.mainPitch, #_flintapp .ViewTsaPage.mainPitch, #_flintapp .TsaPage > .mainPitch",
      "$headline": "#_flintapp headline.TsaPage, #_flintapp .TsaPage.headline, #_flintapp .ViewTsaPage.headline, #_flintapp .TsaPage > .headline",
      "$bullets": "#_flintapp bullets.TsaPage, #_flintapp .TsaPage.bullets, #_flintapp .ViewTsaPage.bullets, #_flintapp .TsaPage > .bullets",
      "$bullet": "#_flintapp bullet.TsaPage, #_flintapp .TsaPage.bullet, #_flintapp .ViewTsaPage.bullet, #_flintapp .TsaPage > .bullet",
      "$goButton": "#_flintapp goButton.TsaPage, #_flintapp .TsaPage.goButton, #_flintapp .ViewTsaPage.goButton, #_flintapp .TsaPage > .goButton",
      "$bonusSection": "#_flintapp bonusSection.TsaPage, #_flintapp .TsaPage.bonusSection, #_flintapp .ViewTsaPage.bonusSection, #_flintapp .TsaPage > .bonusSection",
      "$bonusHeadline": "#_flintapp bonusHeadline.TsaPage, #_flintapp .TsaPage.bonusHeadline, #_flintapp .ViewTsaPage.bonusHeadline, #_flintapp .TsaPage > .bonusHeadline",
      "$bonusModules": "#_flintapp bonusModules.TsaPage, #_flintapp .TsaPage.bonusModules, #_flintapp .ViewTsaPage.bonusModules, #_flintapp .TsaPage > .bonusModules",
      "$testimonials": "#_flintapp testimonials.TsaPage, #_flintapp .TsaPage.testimonials, #_flintapp .ViewTsaPage.testimonials, #_flintapp .TsaPage > .testimonials",
      "$Testimonial": "#_flintapp .ViewTsaPage .ViewTestimonial"
    }, {
      "$tsa": {
        padding: [60, 60, 0]
      },
      "$topSection": {},
      "$tsaBookLink": {
        flexShrink: 0,
        position: 'relative',
        top: -7
      },
      "$tsaBookImg": {},
      "$mainPitch": {
        alignItems: 'center',
        textAlign: 'center'
      },
      "$headline": {
        marginTop: 8,

        fontWeight: 'bold',
        color: 'white'
      },
      "$bullets": {
        marginTop: 10
      },
      "$bullet": {
        color: 'white',
        display: 'inline',

        fontWeight: 'bold',
        marginBottom: 20
      },
      "$goButton": {
        border: 'outset rgb(215, 154, 70)',

        fontWeight: 'bold',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        cursor: 'pointer',
        color: 'black'
      },
      "$bonusSection": {
        alignSelf: 'stretch',
        alignItems: 'center'
      },
      "$bonusHeadline": {
        marginTop: 0,

        fontWeight: 'bold',
        color: 'white'
      },
      "$bonusModules": {
        width: 300,

        marginTop: 20
      },
      "$testimonials": {
        alignSelf: 'stretch',
        alignItems: 'flex-end',
        justifyContent: 'space-between',
        marginTop: 64,
        marginBottom: 16
      },
      "$Testimonial": {
        marginBottom: 24
      }
    });
    Flint.view("TsaPage", function (view, on, $) {
      var context = initContext(view, {
        width: atom(),
        isMobile: atom()
      });

      on.mount(function () {
        M.mixpanel.track("PageView", { page: '3sa' });
      });view.render(function () {
        return view.el(["NavBar", 1], null);
      });view.render(function () {
        return view.el(
          ["tsa", 1],
          null,
          view.el(
            ["topSection", 1],
            null,
            view.el(
              ["Link", 1],
              { className: "tsaBookLink",
                to: "http://threesecondattraction.com",
                target: "_blank"
              },
              view.el(["img", 1], { className: "tsaBookImg", src: "/images/3sa-book.png" })
            ),
            view.el(
              ["mainPitch", 1],
              null,
              view.el(
                ["headline", 1],
                null,
                "The proven system for being naturally charming with women"
              ),
              view.el(
                ["bullets", 1],
                null,
                view.el(
                  ["bullet", 1],
                  null,
                  "Step-by-step guide to being an amazing conversationalist"
                ),
                view.el(
                  ["bullet", 2],
                  null,
                  "The one trick for ",
                  view.el(
                    ["b", 1],
                    null,
                    "fun"
                  ),
                  " and ",
                  view.el(
                    ["b", 2],
                    null,
                    "natural "
                  ),
                  "interactions with women"
                ),
                view.el(
                  ["bullet", 3],
                  null,
                  "Increase romantic interactions everywhere in your life"
                )
              ),
              view.el(
                ["Link", 2],
                { className: "goButton",
                  to: "http://threesecondattraction.com",
                  target: "_blank"
                },
                "Get started"
              )
            )
          ),
          view.el(
            ["bonusSection", 1],
            null,
            view.el(
              ["bonusHeadline", 1],
              null,
              "Includes 12 bonus modules!"
            ),
            view.el(["img", 2], { className: "bonusModules", src: "/images/3sa-bonus-modules.png" })
          ),
          view.el(
            ["testimonials", 1],
            null,
            view.el(
              ["Testimonial", 1],
              {
                name: "Gordy P",
                location: "Tempe, AZ",
                picUrl: "/images/testimonials/gordy-p.png"
              },
              "I thought I was too old to flirt with girls younger than 40... yesterday I got a date with a 27 year old model. This is fishing with dynamite!"
            ),
            view.el(
              ["Testimonial", 2],
              {
                name: "Andrew L",
                location: "Dayton, OH",
                picUrl: "/images/testimonials/andrew-l.png"
              },
              "I thought this approach was BS until I tried it. It lands like an atom bomb! I’m nothing to look at, but with the 3 second secret, it’s ON."
            ),
            view.el(
              ["Testimonial", 3],
              {
                name: "Cuvel T",
                location: "Toronto, Canada",
                picUrl: "/images/testimonials/cuvel-t.png"
              },
              "Why you didn’t call this method your Stealth P***y Getting System, I’ll never know. But that’s exactly what it is."
            )
          )
        );
      });view.render(function () {
        return view.el(["Footer", 1], null);
      });

      "732f13c1";

      $["tsa"] = function (_, _index) {
        return {
          width: context.width.get(),
          background: 'linear-gradient(to bottom, ' + 'rgb(157, 25, 38) 0%, rgb(254, 61, 80) 100%)', marginBottom: context.isMobile.get() ? 20 : 50,
          borderRadius: context.isMobile.get() ? 0 : 12
        };
      };

      $["topSection"] = function (_, _index) {
        return {
          flexDirection: context.isMobile.get() ? 'column' : 'row'
        };
      };

      "2c8a1e71";

      $["tsaBookLink"] = function (_, _index) {
        return { alignSelf: context.isMobile.get() ? 'center' : null
        };
      };

      $["tsaBookImg"] = function (_, _index) {
        return {
          width: Math.max(200, .28 * context.width.get()),
          height: 1086 / 610 * Math.max(200, .28 * context.width.get())
        };
      };

      "671200a6";

      $["mainPitch"] = function (_, _index) {
        return {
          marginLeft: context.isMobile.get() ? 0 : 30 };
      };

      "e4410de4";

      $["headline"] = function (_, _index) {
        return { fontSize: Math.max(18, .037 * context.width.get()), marginBottom: .028 * context.width.get()
        };
      };

      "650ac038";
      "0ee4a846";

      $["bullet"] = function (_, _index) {
        return { fontSize: Math.max(13, .02 * context.width.get()) };
      };

      "1e756083";

      $["goButton"] = function (_, _index) {
        return {
          marginTop: .03 * context.width.get(),
          marginBottom: .08 * context.width.get(),
          width: .4 * context.width.get(),
          height: .1 * context.width.get(),
          background: 'linear-gradient(to bottom, ' + 'rgb(255, 227, 61) 0%, rgb(255, 182, 46) 100%)', borderWidth: .012 * context.width.get(),
          borderRadius: .15 * context.width.get(),
          fontSize: Math.max(12, .023 * context.width.get()) };
      };

      "79d11dcc";
      "2f474bce";

      $["bonusHeadline"] = function (_, _index) {
        return { fontSize: Math.max(16, .025 * context.width.get()) };
      };

      "e75221d6";

      $["bonusModules"] = function (_, _index) {
        return { height: 324 / 684 * 300 };
      };

      "8c8ab2b4";

      $["testimonials"] = function (_, _index) {
        return {
          flexDirection: context.isMobile.get() ? 'column' : 'row' };
      };

      "1d621998";

      $["Testimonial"] = function (_, _index) {
        return {
          width: context.isMobile.get() ? null : (context.width.get() - 160) / 3 };
      };
    });
  })
})();
//# sourceMappingURL=tsaPage.js.map
